export const REGIOES_BR = ['Norte', 'Nordeste', 'Centro-Oeste', 'Sudeste', 'Sul']

export const ESTADO_PARA_REGIAO = {
  Acre: 'Norte',
  Amapá: 'Norte',
  Amazonas: 'Norte',
  Pará: 'Norte',
  Rondônia: 'Norte',
  Roraima: 'Norte',
  Tocantins: 'Norte',
  Alagoas: 'Nordeste',
  Bahia: 'Nordeste',
  Ceará: 'Nordeste',
  Maranhão: 'Nordeste',
  Paraíba: 'Nordeste',
  Pernambuco: 'Nordeste',
  Piauí: 'Nordeste',
  'Rio Grande do Norte': 'Nordeste',
  Sergipe: 'Nordeste',
  'Distrito Federal': 'Centro-Oeste',
  Goiás: 'Centro-Oeste',
  'Mato Grosso': 'Centro-Oeste',
  'Mato Grosso do Sul': 'Centro-Oeste',
  'Espírito Santo': 'Sudeste',
  'Minas Gerais': 'Sudeste',
  'Rio de Janeiro': 'Sudeste',
  'São Paulo': 'Sudeste',
  Paraná: 'Sul',
  'Rio Grande do Sul': 'Sul',
  'Santa Catarina': 'Sul',
}

export const ESTADOS_BR = Object.keys(ESTADO_PARA_REGIAO).sort((a, b) =>
  a.localeCompare(b, 'pt-BR'),
)

export function regiaoPorEstado(estado) {
  if (!estado?.trim()) return null
  return ESTADO_PARA_REGIAO[estado.trim()] ?? null
}

export function isRegiaoValidaParaEstado(estado, regiao) {
  const esperada = regiaoPorEstado(estado)
  if (!esperada || !regiao?.trim()) return false
  return esperada === regiao.trim()
}
